import { render, staticRenderFns } from "./NetFriendNeed.vue?vue&type=template&id=750b1e3a&scoped=true"
import script from "./NetFriendNeed.vue?vue&type=script&lang=ts"
export * from "./NetFriendNeed.vue?vue&type=script&lang=ts"
import style0 from "./NetFriendNeed.vue?vue&type=style&index=0&id=750b1e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750b1e3a",
  null
  
)

export default component.exports